import styled from 'styled-components';
import { device } from '@/utils/devices-screens';

export const SubheaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 80px;
    margin-bottom: 0px;
    padding: 15px 0 0 133px;
    
    @media ${device.tablet}{
        align-items: center;
        padding-left: 0;
        margin-bottom: 15px;
    }

    button {
        width: min-content;
        background: transparent;
        border: none;
        cursor: pointer;
    }

    p {
        margin-bottom: 10px;
        font-weight: 400;
    }

    img {
        max-width: 220px;
        @media ${device.tablet}{
            max-width: 260px;
        }
    }

`;

export const MainContainer = styled.main`
    flex: 1 0 auto;
    margin-left: 130px;
    margin-right: 130px;
    margin-top: 30px;

    @media ${device.tablet} {
        margin-right: 0;
        margin-left: 0;
        margin-top: 0px;
    }
`;

export const FooterContainer = styled.footer`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgb(247, 246, 247);
    padding: 40px 0px;
`;

export const FooterLinks = styled.div`
    display: flex;
    flex-direction: column;

    ul {
        width: 100%;
        flex-wrap: wrap;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        padding: 0px;
        margin-bottom: 0px;
        gap: 10px;
    }

    li {
        list-style: none;
    }

    li a {
        text-decoration: none;
        color: rgb(20, 126, 181);
    }
`;

export const FooterAllRights = styled.footer`
    margin-top: 15px;
    p {
        font-size: 14px;
        color: rgb(20, 126, 181);
        text-align: center;
        font-weight: 400;
    }
`;
